document.addEventListener('DOMContentLoaded', ()=>{
    let request = window.location.href;

    let losesnav = document.querySelector('.account__navloses');
    let accountnav = document.querySelector('.account__navacclink');

    let accountcontent = document.querySelector('.account');
    let losescontent = document.querySelector('.loses');

    
    if(request.indexOf('?loses') > -1){
        losesnav.setAttribute('aria-current', 'page');
        accountnav.removeAttribute('aria-current');
        accountcontent.style.display = 'none';
    } else {
        if(losescontent){
            losescontent.style.display ='none';
        }
    }


	// Countdown Timer Function
	function startCountdown(timerElement, countdownDate) {
		let countDownDate = new Date(countdownDate).getTime();

		let countdownFunction = setInterval(function() {

			let now = new Date().getTime();

			let distance = countDownDate - now;

			let days = Math.floor(distance / (1000 * 60 * 60 * 24));
			let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			//let hours = Math.floor(distance / (1000 * 60 * 60));
			let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			let seconds = Math.floor((distance % (1000 * 60)) / 1000);

			timerElement.querySelector(".orca_days").innerHTML = days;
			timerElement.querySelector(".orca_hours").innerHTML = hours;
			timerElement.querySelector(".orca_minutes").innerHTML = minutes;
			//timerElement.querySelector(".orca_seconds").innerHTML = seconds;

			// If the countdown is over, update the element with "EXPIRED"
			if (distance < 0) {
				clearInterval(countdownFunction);
				timerElement.innerHTML = "EXPIRED";
			}
		}, 1000);
	}

	// Apply countdown to all elements with class "message__timers"
	document.querySelectorAll('.message__timers').forEach(function(timerElement) {
		let date = timerElement.dataset.time;
		if (date) {
			startCountdown(timerElement, date);
		}
	});


	//found it in dev ... we might need it in the future....MN
    // const imageSlider = (sliderElm) => {
    //     const sliderIdentifier = sliderElm.dataset.swiper;

    //     return new Swiper(`#${sliderElm.dataset.swiper}`, {
    //         cssMode: true,
    //         observer: true,
    //         observeSlideChildren: true,
    //         slidesPerView: 2,
    //         spaceBetween: 16,
    //         navigation: {
    //             nextEl: `.swiper-btn-next-${sliderIdentifier}`,
    //             prevEl: `.swiper-btn-prev-${sliderIdentifier}`
    //         }
    //     })
    // }

    // let is = document.querySelectorAll('.imagesliderlist');

    // if( is.length > 0 ){
    //     is.forEach((item)=> imageSlider(item));
    // }

    // this js is responsible to fix the z-index of the popup form ----> start
    document.addEventListener('click', function (e) {
        // Check if the clicked element has the class 'klaviyo-close-form'
        if (e.target.closest('.klaviyo-close-form')) {
          // Find the closest parent dialog
          const dialog = e.target.closest('div[role="dialog"][aria-modal="true"][aria-label="POPUP Form"]');
          if (dialog) {
            dialog.style.display = 'none';
          }
        }
    });
    // this js is responsible to fix the z-index of the popup form ----> end
      
});